// extracted by mini-css-extract-plugin
export default {"wrapper":"Benefit_wrapper__v4a8u","title":"Benefit_title__qBkMs","gridBox":"Benefit_gridBox__INMB3"};